module.exports = __webpack_public_path__ + "media/src/images/logos/slack-55c4da23c8874d28d849ba6f116a7ac0.png";